module.exports = __webpack_public_path__ + "img/example2.6bc4f2ec.jpg";